{
  "home": {
    "heroBadge": "UK's trusted card auction house",
    "heroTitleLine1": "The UK's Premier",
    "heroTitleLine2": "Trading Card Marketplace",
    "heroSubtitle": "Buy and sell graded and authenticated trading cards including Pokémon, One Piece, Gundam, Sports Cards, Magic: The Gathering, Yu-Gi-Oh!, Dragon Ball Super, Disney Lorcana and more through secure live auctions across the UK.",
    "browseCta": "Browse Live Auctions",
    "sellCta": "Start Selling",
    "searchPlaceholder": "Search cards, figures, clothing and more…",
    "searchButton": "Search",
    "popularLabel": "Popular",
    "liveNow": "Live Now",
    "endingTodayCount": "{count} auctions ending today",
    "highestBid": "Highest bid",
    "endsIn": "Ends in",
    "watchingCount": "{count} watching",
    "viewLive": "View live",
    "categoriesEyebrow": "Browse by category",
    "categoriesTitle": "Shop what you love",
    "viewAll": "View all",
    "exploreCta": "Explore",
    "statCardsListed": "Cards Listed",
    "statCollectors": "Collectors",
    "statVolume": "Auction Volume",
    "statRating": "Seller Rating",
    "statSecurePayments": "Secure Payments",
    "statSecurePaymentsDescription": "Payments processed securely by Stripe.",
    "statNoRatingsYet": "No ratings yet",
    "statNewMarketplace": "New Marketplace",
    "statReviewsCount": "{count, plural, one {# review} other {# reviews}}"
  },
  "seo": {
    "trustedMarketplaceEyebrow": "A trusted UK marketplace",
    "introTitle": "Trade the World's Most Popular Trading Cards",
    "introBody1": "BidNova Auctions is a trusted UK marketplace for buying and selling graded trading cards. We support collectors across every major TCG and sports category, with transparent bidding, secure Stripe payments and full buyer protection.",
    "weSupportLabel": "We support collectors of",
    "introBody2": "Whether you're collecting PSA, BGS or CGC graded cards or looking for rare raw cards, BidNova provides a secure marketplace with buyer protection and trusted sellers.",
    "categoriesEyebrow": "Browse by category",
    "categoriesTitle": "Trading Card Categories",
    "trustEyebrow": "Why collectors choose BidNova",
    "trustTitle": "Bid with confidence",
    "trustSecureTitle": "100% Secure Payments",
    "trustSecureBody": "Powered by Stripe with full PCI-DSS compliance and 3-D Secure.",
    "trustVerifiedTitle": "Verified Sellers",
    "trustVerifiedBody": "Identity verification and continuous fraud protection on every listing.",
    "trustProtectionTitle": "Buyer Protection",
    "trustProtectionBody": "Transparent bidding, secure checkout and refunds on non-delivery.",
    "trustGradingTitle": "Professional Grading",
    "trustGradingBody": "Support for PSA, BGS, CGC, SGC, ACE, PG and TAG graded cards — with automatic certificate verification for PSA, BGS, CGC and SGC.",
    "sellerCtaEyebrow": "For sellers",
    "sellerCtaTitle": "Sell Your Trading Cards with Confidence",
    "sellerCtaBody": "Reach collectors across the UK through secure timed auctions. A simple flat 8% commission on successful sales only — no listing fees, no monthly fees, no subscriptions. Real-time bidding, secure payouts and full order tracking from listing to delivery.",
    "sellerCtaButton": "Start Selling Today",
    "collectionsEyebrow": "Supported collections",
    "collectionsTitle": "Every major TCG and sports card line",
    "faqEyebrow": "FAQ",
    "faqTitle": "Frequently asked questions"
  },
  "faq": {
    "q1": "How do online trading card auctions work?",
    "a1": "Sellers list a card with a starting price, duration and optional Buy It Now. Registered buyers place bids in real time. When the timer ends, the highest bidder wins and pays securely through Stripe — the seller then ships the card, tracked, with full buyer protection.",
    "q2": "Can I sell Pokémon cards?",
    "a2": "Yes. Pokémon is our largest category. You can list raw cards or cards graded by PSA, BGS, CGC, SGC, ACE, PG or TAG — single lots or sealed products, from vintage Base Set to modern Scarlet & Violet.",
    "q3": "Can I sell One Piece cards?",
    "a3": "Yes. BidNova supports the full One Piece Card Game — from Romance Dawn and Paramount War onwards, including manga rares, alt arts and graded slabs.",
    "q4": "Can I auction Sports Cards?",
    "a4": "Yes. Football, basketball, baseball, F1, UFC and other sports cards are all supported — including Topps, Panini Prizm, Select, Donruss and Bowman.",
    "q5": "What grading companies are supported?",
    "a5": "BidNova accepts cards graded by PSA, BGS, CGC, SGC, ACE, PG and TAG. Certificate numbers are automatically verified for PSA, BGS, CGC and SGC; ACE, PG and TAG cards can be listed with manual entry.",
    "q6": "How are buyers protected?",
    "a6": "Every transaction runs through Stripe with 3-D Secure. Sellers are identity-verified, listings are moderated, and buyers can open a dispute for non-delivery, damage or misdescription and receive a refund under our buyer protection policy.",
    "q7": "What does it cost to sell on BidNova?",
    "a7": "BidNova charges a simple 8% commission on successful sales only. No monthly fees. No subscription fees. No listing fees."
  },
  "browse": {
    "eyebrow": "Marketplace",
    "defaultH1": "Live Auctions",
    "categoryH1": "{category} Card Auctions",
    "defaultIntro": "Browse every live trading card auction on BidNova Auctions — the UK's trusted marketplace for graded Pokémon, One Piece, Yu-Gi-Oh!, Dragon Ball, Magic: The Gathering and sports cards. Every listing is priced in GBP, protected by Stripe-secured payments and covered by our buyer protection guarantee. Filter by Buy It Now, grading company (PSA, BGS, CGC, ACE), price and time remaining, or use AI Smart Search to describe exactly what you're looking for.",
    "categoryIntro": "Live UK auctions for {category} trading cards on BidNova Auctions. Priced in GBP, protected by Stripe-secured payments and covered by our buyer protection guarantee. Filter by Buy It Now, grading company (PSA, BGS, CGC, ACE), price and time remaining.",
    "allCategories": "All categories",
    "marketTrends": "Market trends",
    "sellACard": "Sell a card",
    "smartSearchPlaceholder": "Try: \"PSA 10 Charizard under £500\" or \"Japanese One Piece manga rare\"",
    "smartSearchButton": "AI Smart Search",
    "smartSearchClear": "Clear",
    "smartSearchAiApplied": "Smart search applied",
    "smartSearchKeywordApplied": "Keyword search applied",
    "smartSearchFailed": "Smart search failed",
    "purchaseMethodPlaceholder": "Purchase method",
    "purchaseAll": "All listings",
    "purchaseAuctionOnly": "Auction only",
    "purchaseBuyNow": "Buy It Now available",
    "purchaseAuctionPlusBin": "Auction + Buy It Now",
    "sortPlaceholder": "Sort",
    "sortEndingSoon": "Ending soon",
    "sortNewlyListed": "Newly listed",
    "sortCurrentBidHigh": "Current bid: high to low",
    "sortBinLow": "Buy It Now: low to high",
    "sortBinHigh": "Buy It Now: high to low",
    "productTypePlaceholder": "Product type",
    "anyProductType": "Any product type",
    "accessoryCategoryPlaceholder": "Accessory category",
    "anyAccessory": "Any accessory",
    "cardTypePlaceholder": "Card type",
    "anyCardType": "Any card type",
    "graderPlaceholder": "Grading company",
    "anyGrader": "Any grading company",
    "gradePlaceholder": "Grade",
    "anyGrade": "Any grade",
    "brandPlaceholder": "Brand",
    "anyBrand": "Any brand",
    "conditionPlaceholder": "Condition",
    "anyCondition": "Any condition",
    "gamePlaceholder": "Compatible game",
    "anyGame": "Any game",
    "productLinePlaceholder": "Product line / set",
    "anySetLine": "Any set / line",
    "tcgGamePlaceholder": "Game",
    "rarityPlaceholder": "Rarity",
    "anyRarity": "Any rarity",
    "languagePlaceholder": "Language",
    "anyLanguage": "Any language",
    "finishPlaceholder": "Finish",
    "anyFinish": "Any finish",
    "editionPlaceholder": "Edition",
    "anyEdition": "Any edition",
    "cardSetPlaceholder": "Card set…",
    "autographedLabel": "Autographed",
    "serialLabel": "Serial #",
    "trustLabel": "Trust",
    "trustVerifiedChip": "Verified",
    "trustPartnerChip": "Official Partner",
    "trustFeaturedChip": "Featured Shop",
    "activeFiltersLabel": "Active filters:",
    "removeGameFilter": "Game",
    "removeRarityFilter": "Rarity",
    "removeAutographedFilter": "Autographed",
    "removeSerialFilter": "Serial #",
    "removeVerifiedFilter": "Verified sellers",
    "removePartnerFilter": "Official partners",
    "removeFeaturedFilter": "Featured shops",
    "removeProductFilter": "Product",
    "removeAccessoryFilter": "Accessory",
    "clearAll": "Clear all",
    "othersOption": "Others",
    "loadError": "We couldn't load the live auctions.",
    "noneMatch": "No live auctions match your filter right now — try widening it, or check back shortly as new listings go live throughout the day.",
    "howBiddingWorksTitle": "How bidding works",
    "howBiddingWorksBody": "Every auction on BidNova runs in GBP with a clear starting price, current bid and countdown to close. Place a bid at or above the next valid increment and, if you're outbid, we'll notify you instantly so you can respond. Some listings also offer a Buy It Now price for immediate purchase. Auctions with activity in the final minutes are automatically extended so no bidder can be sniped at the last second.",
    "biddingPoint1": "Bid transparently — see every bid, bidder count and time remaining.",
    "biddingPoint2": "Automatic anti-sniping extension protects fair competition.",
    "biddingPoint3": "Winning bidders check out securely with card, Apple Pay or Google Pay via Stripe.",
    "biddingPoint4": "Sellers ship tracked; you confirm delivery before funds release.",
    "buyerProtectionTitle": "Buyer protection & seller trust",
    "buyerProtectionBody": "BidNova Auctions is a UK-registered, fully GDPR-compliant marketplace. Payments are processed by Stripe and held until you confirm the card arrived as described. Sellers are verified, carry public ratings and are governed by our Seller Agreement — with a formal dispute process if anything isn't right.",
    "protectionPoint1": "Secure Stripe payments — seller payouts only release after delivery confirmation.",
    "protectionPoint2": "Verified sellers with public ratings and shipment tracking.",
    "protectionPoint3": "Formal dispute resolution for damaged, missing or misdescribed cards.",
    "protectionPoint4": "UK-registered platform, prices in GBP, governed by the laws of England & Wales."
  },
  "seller": {
    "loading": "Loading…",
    "loadingListings": "Loading listings…",
    "profileUnavailableTitle": "Seller profile unavailable",
    "profileUnavailableBody": "This seller has not published a public profile yet.",
    "browseAllAuctions": "Browse all auctions",
    "website": "Website",
    "noReviewsYet": "No reviews yet",
    "reviewCount": "{count, plural, one {(# review)} other {(# reviews)}}",
    "positivePct": "{pct}% positive",
    "completedSalesCount": "{count, plural, one {# completed sale} other {# completed sales}}",
    "memberSince": "Member since {date}",
    "statTotalAuctions": "Total auctions",
    "statTotalSales": "Total sales",
    "statSuccessfulSales": "Successful sales",
    "statAverageFeedback": "Average feedback",
    "statPositiveFeedback": "Positive feedback",
    "statVerification": "Verification",
    "verified": "Verified",
    "community": "Community",
    "featuredProducts": "Featured products",
    "activeAuctions": "Active auctions",
    "noActiveListings": "This seller has no active listings.",
    "recentlyEnded": "Recently ended",
    "recentReviews": "Recent reviews",
    "somethingWentWrong": "Something went wrong",
    "tryAgain": "Try again",
    "notFoundTitle": "Seller not found",
    "returnHome": "Return home",
    "loadingReviews": "Loading reviews…",
    "reviewsCouldNotLoad": "Reviews couldn't be loaded.",
    "noReviewsBody": "This seller has no reviews yet.",
    "loadMoreReviews": "Load more reviews",
    "loadingMore": "Loading…",
    "anonymousBuyer": "BidNova Auctions buyer",
    "noWrittenComment": "No written comment",
    "reported": "Reported",
    "signInToReport": "Sign in to report this review",
    "report": "Report",
    "reportThisReview": "Report this review",
    "reportDialogTitle": "Report this review",
    "reportDialogDescription": "Tell our moderators why this review breaches our policies. Your report is private and reviewed by the BidNova Auctions team.",
    "reportReasonLabel": "Reason",
    "reportPlaceholder": "e.g. contains personal information, spam, abusive language…",
    "reportTooShort": "At least {min} characters required",
    "reportLooksGood": "Looks good",
    "cancel": "Cancel",
    "submitReport": "Submit report",
    "reportSubmitted": "Report submitted. Thanks for flagging.",
    "reportMinChars": "Please provide at least {min} characters",
    "reportTooLong": "Reason is too long",
    "reportSubmitFailed": "Could not submit report",
    "loadMoreFailed": "Could not load more reviews"
  },
  "hoverCard": {
    "fallbackName": "Seller",
    "successfulSales": "Successful sales",
    "positiveFeedback": "Positive feedback",
    "memberSince": "Member since",
    "rating": "Rating",
    "viewProfile": "View profile"
  },
  "card": {
    "priceHistory": "Price history (180 days)",
    "populationReport": "Population report",
    "catalogEyebrow": "Card catalog",
    "loading": "Loading…",
    "notFound": "Card not found."
  },
  "trends": {
    "title": "Market Trends",
    "subtitle": "Derived from real BidNova sales only. Advisory — not a valuation.",
    "trendingCards": "Trending cards",
    "categoryActivity": "Category activity",
    "unknownSet": "unknown set",
    "salesCount": "{count} sales",
    "averagePrefix": "avg {price}",
    "noTrendData": "No trend data yet for this window. Trends appear as real BidNova sales accumulate.",
    "noActivityData": "No activity yet for this window.",
    "notFound": "Not found."
  },
  "accessories": {
    "eyebrow": "Accessories",
    "breadcrumbHome": "Home",
    "breadcrumbAuctions": "Auctions",
    "breadcrumbAccessories": "Accessories",
    "relatedCategories": "Related accessory categories",
    "allAccessories": "All accessories",
    "noListingsBody": "No {category} are live right now. New listings go up throughout the day — browse {link} or check back shortly.",
    "allAccessoryListings": "all accessory listings",
    "couldNotLoad": "We couldn't load these listings.",
    "whyBuyTitle": "Why buy accessories on BidNova",
    "whyBuyBody": "BidNova is a UK-registered marketplace. Every accessory is sold by a verified seller with a public rating, priced in GBP, and paid via Stripe. Funds are held until you confirm your order arrives as described.",
    "whyBuyPoint1": "Stripe-secured payments with buyer protection.",
    "whyBuyPoint2": "Verified UK sellers with public ratings and dispute resolution.",
    "whyBuyPoint3": "Prices in GBP — no surprise conversion fees.",
    "sellingTitle": "Selling accessories?",
    "sellingBody": "Approved sellers can list accessories alongside singles and sealed product from one dashboard. Grading fields don't apply to accessories — just add photos, condition and a starting price.",
    "listAnAccessory": "List an accessory"
  },
  "auctionDetail": {
    "notFoundTitle": "Auction not found",
    "notFoundBody": "This URL doesn't look right — try browsing live auctions."
  },
  "sell": {
    "stripeGateTitle": "Complete Stripe onboarding to list",
    "stripeGateBody": "BidNova Auctions pays sellers via Stripe Connect. You need a Stripe Express account with charges and payouts enabled before you can publish an auction. It takes just a few minutes.",
    "detailsSubmitted": "Details submitted",
    "chargesEnabled": "Charges enabled",
    "payoutsEnabled": "Payouts enabled",
    "continueOnboarding": "Continue Stripe onboarding",
    "startOnboarding": "Start Stripe onboarding",
    "stripeStatusUpdated": "Stripe status updated"
  },
  "cookieConsent": {
    "ariaLabel": "Cookie consent",
    "heading": "Cookies & privacy",
    "body": "We use strictly necessary cookies to run the site (authentication, security, checkout). With your consent we also use optional analytics and marketing cookies to improve the auctions and personalise offers. You can change your mind at any time via the footer.",
    "readPolicy": "Read our Cookie Policy",
    "necessaryTitle": "Strictly necessary",
    "necessaryBody": "Always on — required for login, security and checkout.",
    "analyticsTitle": "Analytics",
    "analyticsBody": "Aggregate usage stats to improve the platform.",
    "marketingTitle": "Marketing",
    "marketingBody": "Personalise offers and measure campaigns.",
    "acceptAll": "Accept all",
    "savePreferences": "Save preferences",
    "customise": "Customise",
    "rejectNonEssential": "Reject non-essential"
  },
  "stats": {
    "cardsListed": "Cards Listed",
    "cardsListedDesc": "Cards listed across live and completed auctions.",
    "collectors": "Collectors",
    "collectorsDesc": "Registered collectors buying and selling on BidNova.",
    "auctionVolume": "Auction Volume",
    "auctionVolumeDesc": "Total value of successfully completed auctions.",
    "sellerRating": "Seller Rating",
    "sellerRatingDesc": "Average rating left by verified buyers.",
    "reviewCount": "{count, plural, one {# review} other {# reviews}}",
    "newMarketplace": "New marketplace",
    "noRatings": "No ratings yet",
    "securePayments": "Secure Payments",
    "securePaymentsDesc": "Payments processed securely by Stripe."
  }
}
